<main class="error-modal-main-box">
	<div (click)="closeModal()" class="close-button icon-box">
		<div (click)="closeModal()" class="svg-icon-error bg-primary icon-box cursor-pointer"></div>
	</div>
	<div class="draft">
		<svg
			class="pen-broken-animation"
			width="229"
			height="181"
			viewBox="0 0 229 181"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M149.734 82.0253L150.541 70.3776L202.532 129.671C202.778 133.692 203.187 139.91 203.622 145.679C204.078 151.731 204.563 157.288 204.92 159.297C205.617 163.219 202.024 164.208 200.14 164.212L185.189 161.563L170.239 158.913L170.251 158.809L117.556 97.9578L127.82 95.44L129.914 91.1457L135.816 79.0436L140.588 80.0659L149.734 82.0253Z"
				class="svg-element-1"
			></path>
			<path
				d="M203.088 121.638L151.098 62.3448L150.291 73.9925L141.145 72.0331M203.088 121.638L192.707 131.008M203.088 121.638C203.335 125.659 203.744 131.877 204.178 137.646M130.471 83.1129L136.373 71.0109L141.145 72.0331M130.471 83.1129L128.376 87.4072L118.113 89.9251L170.808 150.776M130.471 83.1129L181.758 140.892M170.808 150.776L170.796 150.88L185.746 153.53M170.808 150.776L181.758 140.892M192.707 131.008L141.145 72.0331M192.707 131.008L181.758 140.892M204.178 137.646C204.635 143.698 205.119 149.256 205.476 151.264C206.173 155.186 202.58 156.175 200.697 156.179L185.746 153.53M204.178 137.646L185.746 153.53"
				class="svg-element-2"
			></path>
			<path
				d="M84.4519 70.0521H71.5685L22.8529 118.768L15.2033 126.417L3.04107 138.898C-0.98487 142.924 1.8335 146.95 3.93034 148.963L20.4373 165.47C20.4373 165.47 26.3926 173.522 30.8213 169.899L44.795 157.716L52.6459 149.961L102.569 100.65V88.1695L93.5106 85.3512L84.4519 82.533V70.0521Z"
				class="svg-element-3"
			></path>
			<path
				d="M22.8529 110.716L71.5685 62H84.4519V68.2404M22.8529 110.716L15.2033 118.365M22.8529 110.716L32.4662 120.781M52.6459 141.909L102.569 92.5982V80.1174L93.5106 77.2991M52.6459 141.909L44.795 149.664M52.6459 141.909L42.556 131.345M44.795 149.664L15.2033 118.365M44.795 149.664L30.8213 161.847C26.3926 165.47 20.4373 157.418 20.4373 157.418L3.93034 140.911C1.8335 138.898 -0.98487 134.872 3.04107 130.846L15.2033 118.365M84.4519 68.2404V74.4808L93.5106 77.2991M84.4519 68.2404L32.4662 120.781M32.4662 120.781L42.556 131.345M42.556 131.345L93.5106 77.2991"
				class="svg-element-4"
			></path>
			<rect x="112.914" y="0.5" width="4" height="30" rx="2" class="svg-element-5"></rect>
			<rect
				x="0.127158"
				y="-0.695579"
				width="4"
				height="30"
				rx="2"
				transform="matrix(0.822738 -0.568421 -0.568421 -0.822738 102.248 32.1952)"
				class="svg-element-6"
			></rect>
			<rect
				x="141.162"
				y="5.73952"
				width="4"
				height="30"
				rx="2"
				transform="rotate(34.6402 141.162 5.73952)"
				class="svg-element-7"
			></rect>
		</svg>

		<svg
			class="draft-svg-pen-balls"
			width="144"
			height="126"
			viewBox="0 0 144 126"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="3" cy="3" r="3" class="svg-elem-1"></circle>
			<circle cx="26" cy="3" r="3" class="svg-elem-2"></circle>
			<circle cx="49" cy="3" r="3" class="svg-elem-3"></circle>
			<circle cx="72" cy="3" r="3" class="svg-elem-4"></circle>
			<circle cx="95" cy="3" r="3" class="svg-elem-5"></circle>
			<circle cx="118" cy="3" r="3" class="svg-elem-6"></circle>
			<circle cx="3" cy="23" r="3" class="svg-elem-7"></circle>
			<circle cx="26" cy="23" r="3" class="svg-elem-8"></circle>
			<circle cx="49" cy="23" r="3" class="svg-elem-9"></circle>
			<circle cx="72" cy="23" r="3" class="svg-elem-10"></circle>
			<circle cx="95" cy="23" r="3" class="svg-elem-11"></circle>
			<circle cx="95" cy="43" r="3" class="svg-elem-12"></circle>
			<circle cx="118" cy="43" r="3" class="svg-elem-13"></circle>
			<circle cx="118" cy="23" r="3" class="svg-elem-14"></circle>
			<circle cx="3" cy="43" r="3" class="svg-elem-15"></circle>
			<circle cx="26" cy="43" r="3" class="svg-elem-16"></circle>
			<circle cx="49" cy="43" r="3" class="svg-elem-17"></circle>
			<circle cx="72" cy="43" r="3" class="svg-elem-18"></circle>
			<circle cx="3" cy="63" r="3" class="svg-elem-19"></circle>
			<circle cx="26" cy="63" r="3" class="svg-elem-20"></circle>
			<circle cx="49" cy="63" r="3" class="svg-elem-21"></circle>
			<circle cx="72" cy="63" r="3" class="svg-elem-22"></circle>
			<circle cx="95" cy="63" r="3" class="svg-elem-23"></circle>
			<circle cx="141" cy="63" r="3" class="svg-elem-24"></circle>
			<circle cx="3" cy="83" r="3" class="svg-elem-25"></circle>
			<circle cx="26" cy="83" r="3" class="svg-elem-26"></circle>
			<circle cx="49" cy="83" r="3" class="svg-elem-27"></circle>
			<circle cx="72" cy="83" r="3" class="svg-elem-28"></circle>
			<circle cx="95" cy="83" r="3" class="svg-elem-29"></circle>
			<circle cx="118" cy="83" r="3" class="svg-elem-30"></circle>
			<circle cx="141" cy="83" r="3" class="svg-elem-31"></circle>
			<circle cx="3" cy="103" r="3" class="svg-elem-32"></circle>
			<circle cx="26" cy="103" r="3" class="svg-elem-33"></circle>
			<circle cx="49" cy="103" r="3" class="svg-elem-34"></circle>
			<circle cx="72" cy="103" r="3" class="svg-elem-35"></circle>
			<circle cx="95" cy="103" r="3" class="svg-elem-36"></circle>
			<circle cx="118" cy="103" r="3" class="svg-elem-37"></circle>
			<circle cx="141" cy="103" r="3" class="svg-elem-38"></circle>
			<circle cx="3" cy="123" r="3" class="svg-elem-39"></circle>
			<circle cx="26" cy="123" r="3" class="svg-elem-40"></circle>
			<circle cx="49" cy="123" r="3" class="svg-elem-41"></circle>
			<circle cx="72" cy="123" r="3" class="svg-elem-42"></circle>
			<circle cx="118" cy="123" r="3" class="svg-elem-43"></circle>
		</svg>
	</div>
	<span class="message">{{ SystemFeedbacks['feedback-error-segmentation'] }}</span>

	<button (click)="closeModal()" class="w-196 btn-type-1 btn-primary mt-[24px]">
		{{ SystemFeedbacks['feedback-error-segmentation-button'] }}
	</button>
</main>
